export const indexAbout = () => {}
